import loginApi from "@services/api/authentication/login";
import type { ILoginInput } from "@services/api/authentication/login/interface";

const handleLogin = async (input: ILoginInput) => {
    const response = await loginApi(input);

    return response.data;

};

export default handleLogin;